import type { RouteRecordRaw } from 'vue-router'

import useAuthUser from '@/composables/useAuthUser'
import useHasPermissionUser from '@/composables/useHasPermissionUser'

export default {
	path: '/company/:companyId/subscriptions',
	name: 'company.subscriptions',
	component: () =>
		import('@/modules/plans/pages/CompanySubscriptionsPage.vue'),
	beforeEnter: (to, from, next) => {
		const { user } = useAuthUser()
		if (!user.value) {
			return next({ path: '/error/not-found' })
		}
		if (String(user.value.companyId) !== String(to.params.companyId)) {
			return next({ path: '/error/not-found' })
		}
		const { hasPermissionUser } = useHasPermissionUser()
		if (!hasPermissionUser('update', 'App\\Models\\Company')) {
			return next({ path: '/error/not-found' })
		}
		return next()
	},
} as RouteRecordRaw
